import React, { FC, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cns from 'classnames';
import {
  getAllSocials,
  changeSocialParam,
  addSocialParam,
  removeSocialParam,
  SocialDto,
  internalizationState,
} from '../../../stores/reducers/sections';
import Input from './Input/Input';
import Icon from '../../Icon';

interface Props {
  className?: string;
}

const Socials: FC<Props> = () => {
  const socials = useSelector(getAllSocials);
  const dispatch = useDispatch();
  const [addOpened, setAddOpened] = useState<boolean>(false);
  const langConfig = useSelector(internalizationState);

  const socialNames = socials.map((x: any) => x.icon);
  const availableNames = ['twitter', 'facebook', 'od', 'insta', 'youtube'];

  const handleSocialUpdate = (value: string, id: number) => {
    dispatch(changeSocialParam({ value, id }));
  };

  const handleSocialAdd = (icon: string) => {
    dispatch(addSocialParam({ icon }));
  };

  const handleSocialRemove = (id: number) => {
    dispatch(removeSocialParam({ id }));
  };

  const getLabelByIcon = (icon: string) => {
    switch (icon) {
      case 'twitter':
        return 'Twitter';
      case 'facebook':
        return 'FB';
      case 'vkontakte':
        return 'VK';
      case 'insta':
        return 'Instagram';
      case 'od':
        return 'OK.ru';
      case 'youtube':
        return 'YouTube';
      default:
        return 'Social name';
    }
  };

  return (
    <>
      <ul className="setting-options">
        {socials &&
          socials.map((social: SocialDto) => (
            <li key={social.icon}>
              <Input
                label={getLabelByIcon(social.icon)}
                icon="bin"
                value={social.link}
                onIconClick={() => handleSocialRemove(social.id)}
                handleChange={(e: string): void => handleSocialUpdate(e, social.id)}
              />
            </li>
          ))}
      </ul>

      <div className="add-social">
        <button type="button" className="btn btn-primary btn--min" onClick={() => setAddOpened(true)}>
          {langConfig.activeLangState === 'ru' ? 'Добавить соцсеть' : 'Add social network'}
        </button>
        <ul className={cns('social-options', addOpened && 'is-open')}>
          <li>
            <button type="button" className="social-options__close" onClick={() => setAddOpened(false)}>
              <Icon name="close" />
            </button>
          </li>

          {availableNames.map(
            (a, idx) =>
              socialNames.indexOf(a) === -1 && (
                <li key={idx} onClick={() => handleSocialAdd(a)}>
                  <Icon name={a} />
                </li>
              )
          )}
        </ul>
      </div>
    </>
  );
};

export default Socials;
